<lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
